import React from "react";
import { Field, ErrorMessage } from "formik";

import { useMembershipRegistrationContext } from "../../context/MembershipRegistrationContext";

export default function SchoolTimelineComponent() {
  const { batches } = useMembershipRegistrationContext();

  return (
    <div
      className="col-12 my-0 rounded-3 border-vcg-muted p-4"
      style={{ backgroundColor: "#fff" }}
    >
      <h4 className="fw-bold mb-4">School Timeline</h4>
      <div className="row g-3">
        {/* School Enrollment Year */}
        <div className="col-md-6">
          <label className="form-label">
            School Admission Year<span className="text-danger">*</span>
          </label>
          <Field
            type="number"
            className="form-control"
            name="schoolEnrollmentYear"
          />
          <ErrorMessage
            name="schoolEnrollmentYear"
            component="div"
            className="text-danger small"
          />
        </div>

        {/* School Enrollment Grade */}
        <div className="col-md-6">
          <label className="form-label">
            School Admission Grade<span className="text-danger">*</span>
          </label>
          <Field
            as="select"
            className="form-select"
            name="schoolEnrollmentGrade"
          >
            <option value="">Select Grade</option>
            {[...Array(13)].map((_, index) => (
              <option key={index + 1} value={index + 1}>
                Grade {index + 1}
              </option>
            ))}
          </Field>
          <ErrorMessage
            name="schoolEnrollmentGrade"
            component="div"
            className="text-danger small"
          />
        </div>

        {/* Last Passed Year */}
        <div className="col-md-6">
          <label className="form-label">
            School Leaving Year<span className="text-danger">*</span>
          </label>
          <Field type="number" className="form-control" name="lastPassedYear" />
          <ErrorMessage
            name="lastPassedYear"
            component="div"
            className="text-danger small"
          />
        </div>

        {/* Last Passed Grade */}
        <div className="col-md-6">
          <label className="form-label">
            School Leaving Grade<span className="text-danger">*</span>
          </label>
          <Field as="select" className="form-select" name="lastPassedGrade">
            <option value="">Select Grade</option>
            {[...Array(13)].map((_, index) => (
              <option key={index + 1} value={index + 1}>
                Grade {index + 1}
              </option>
            ))}
          </Field>
          <ErrorMessage
            name="lastPassedGrade"
            component="div"
            className="text-danger small"
          />
        </div>

        {/* Batch Dropdown */}
        <div className="col-md-6">
          <label className="form-label">
            Batch<span className="text-danger">*</span>
          </label>
          <Field as="select" className="form-select" name="batch">
            <option value="">Select Batch</option>
            {batches.map((batch) => (
              <option key={batch.id} value={batch.id}>
                {batch.name}
              </option>
            ))}
          </Field>
          <ErrorMessage
            name="batch"
            component="div"
            className="text-danger small"
          />
        </div>

        {/* Advanced Level Stream */}
        <div className="col-md-6">
          <label className="form-label">Advanced Level Stream</label>
          <Field as="select" className="form-select" name="advancedLevelStream">
            <option value="">Select Stream</option>
            <option value="1">Biological Science</option>
            <option value="2">Physical Science</option>
            <option value="3">Commerce</option>
            <option value="4">Arts</option>
            <option value="5">Technology</option>
            <option value="6">Other Stream</option>
          </Field>
          <ErrorMessage
            name="advancedLevelStream"
            component="div"
            className="text-danger small"
          />
        </div>
      </div>
    </div>
  );
}
